import React, { lazy } from 'react';
import { LINKS } from '../lib/links';
import { FadeIn } from './FadeIn';
import { Instagram, Facebook } from 'lucide-react';
const FEED_IMAGES = ['https://cdn.magicpatterns.com/uploads/159D69XqkjH3tXZBxvtdbs/544792890_122198079740570946_7016239850407119729_n_(1).jpg', 'https://cdn.magicpatterns.com/uploads/hffDynZX3nXn2CNTPNVY6M/471428511_122131322642570946_6342459253165615123_n.jpg', 'https://cdn.magicpatterns.com/uploads/fmtH8Qe3zLSajMFbpr2NQu/471248740_122128867304570946_7521978610206292011_n.jpg', 'https://cdn.magicpatterns.com/uploads/2R6iFsj5APGTGwRYAVkiFK/470801593_122128867442570946_8740882224121444447_n.jpg', 'https://cdn.magicpatterns.com/uploads/8jw5SDRb5f5nVzkkgx9KD2/470562478_122128866854570946_8321049361434838301_n.jpg', 'https://cdn.magicpatterns.com/uploads/tCCtuiYevJjrLRPGX4h7mj/470823327_122128867136570946_1434913759190205541_n.jpg', 'https://cdn.magicpatterns.com/uploads/9u6tyMyibEF3BymtNxTkix/2025-10-28_(1).webp', 'https://cdn.magicpatterns.com/uploads/ffnbPcW2MxKqF2667fz2MN/542760348_122198079770570946_2686341410234026026_n_(1).jpg', 'https://cdn.magicpatterns.com/uploads/m4hVoN9mtjeNnASznCQJRM/542755915_122198079710570946_106348140338141339_n_(1).jpg'];
export function LivingFeed() {
  return <section className="py-20 md:py-32 px-6 md:px-12 bg-cream relative" data-id="element-123">
      <div className="max-w-6xl mx-auto" data-id="element-124">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-end mb-12 gap-6" data-id="element-125">
          <div data-id="element-126">
            <FadeIn data-id="element-127">
              <p className="text-clay/70 uppercase tracking-[0.2em] text-xs font-medium mb-4" data-id="element-128">
                From the Land
              </p>
            </FadeIn>
            <FadeIn delay={0.1} data-id="element-129">
              <h2 className="font-serif text-3xl md:text-4xl text-pine" data-id="element-130">
                See what's happening
                <br className="hidden md:block" data-id="element-131" /> on the land.
              </h2>
            </FadeIn>
          </div>

          <FadeIn delay={0.2} className="flex gap-5" data-id="element-132">
            <a href={LINKS.instagram} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-pine hover:text-ember transition-colors text-sm uppercase tracking-widest" data-id="element-133">
              <Instagram className="w-4 h-4" data-id="element-134" />
              Instagram
            </a>
            <span className="text-pine/20" data-id="element-135">|</span>
            <a href={LINKS.facebook} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-pine hover:text-ember transition-colors text-sm uppercase tracking-widest" data-id="element-136">
              <Facebook className="w-4 h-4" data-id="element-137" />
              Facebook
            </a>
          </FadeIn>
        </div>

        <div className="grid grid-cols-3 gap-2 md:gap-3" data-id="element-138">
          {FEED_IMAGES.map((img, idx) => <FadeIn key={idx} delay={idx * 0.04} data-id="element-139">
              <a href={LINKS.instagram} target="_blank" rel="noopener noreferrer" className="block aspect-square overflow-hidden group bg-cream rounded-sm" data-id="element-140">
                <img src={img} alt="Retreat atmosphere" loading="lazy" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" data-id="element-141" />
              </a>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}